/*eslint max-len: 0*/
/*eslint no-param-reassign: 0*/
/*eslint no-console: 0*/

module.exports = (function () {
    'use strict';
    const {
        isUfeEnvQA,
        isUfeEnvLocal
    } = require('utils/Env');

    const Perf = require('utils/framework/Perf');
    const emotion = require('emotion');

    var React = require('react'),
        ReactDOM = require('react-dom'),
        Comps = {},
        InflatorComps = Sephora.Util.InflatorComps,
        startTime;

    // For render time performance logging
    if (isUfeEnvQA || isUfeEnvLocal) {
        Sephora.Util.InflatorComps.totalRenderTime = 0;
        Sephora.Util.InflatorComps.totalInclusiveRenderTime = 0;
        Sephora.Util.InflatorComps.rootRenderTime = 0;
    }

    // All Async Loadable Components Should Be Included Here
    // It is possible for InflatorComps.Comps to already exist at this point so check first
    Comps = InflatorComps.Comps = InflatorComps.Comps ? InflatorComps.Comps : {};
    var asyncComponents = require('build/asyncList');
    Object.assign(Comps, asyncComponents);

    /**
     * Fires the callback only when all events have been fired
     * @param target
     * @param events
     * @param callback
     */
    var services = InflatorComps.services;

    /**
     * Actually render the component (wraps react)
     * @param componentClass
     * @param props
     * @param element
     * @returns {*}
     */
    InflatorComps.render = function (componentClass, props, element, hydrate = true) {
        var createdReactElement,
            renderedElement;

        if (typeof componentClass === 'string') {
            componentClass = Comps[componentClass].getReactClass();
        } else if (Comps[componentClass.prototype.class] === undefined) {
            // TO DO: It looks like this code may never be used. Could possibly be cleaned up.
            Comps[componentClass.prototype.class] = {};
            Comps[componentClass.prototype.class].class = componentClass.prototype.originClass;
            Comps[componentClass.prototype.class].getReactClass = function () {
                return componentClass;
            };
        }

        var render = (!hydrate || componentClass.prototype.renderOnLoadEvent) ? ReactDOM.render : ReactDOM.hydrate;

        // Mark root components with red border
        if (process.env.NODE_ENV === 'development' && Sephora.debug.showRootComps) {
            element.style.border = '1px solid red';
        }

        if (typeof props === 'string') {
            try {
                props = JSON.parse(props);
            } catch (e) {
                console.error(e);
                return null;
            }
        } else {
            props = props;
        }

        // For render time performance logging
        if (isUfeEnvQA || isUfeEnvLocal) {
            startTime = performance.now();
        }

        createdReactElement = React.createElement(componentClass, props);
        renderedElement = render(createdReactElement, element);

        //For render time performance logging
        if (isUfeEnvQA || isUfeEnvLocal) {
            let comp = InflatorComps.Comps[componentClass.prototype.class].getReactClass();
            if (!comp.rootRenderTime) {
                InflatorComps.Comps[componentClass.prototype.class].rootRenderTime = 0;
            }
            let renderTime = performance.now() - startTime;
            InflatorComps.Comps[componentClass.prototype.class].rootRenderTime += renderTime;
            Sephora.Util.InflatorComps.rootRenderTime += renderTime;
        }

        return renderedElement;
    };

    let fireAppliedEvent = function (service) {
        Perf.report(service + ' Service Ctrlrs Applied');
        window.dispatchEvent(new CustomEvent(service + 'CtrlrsApplied', { detail: {} }));
        services.loadEvents[service + 'CtrlrsApplied'] = true;
    };

    /**
     * Called when a service is ready so all dependent components can be rendered
     * and their controllers applied
     * @param service
     */
    InflatorComps.renderQueue = function (service, hydrate = true) {
        var component;

        Perf.report(service + ' Service AsyncRendering');

        if (services[service] && services[service].queue) {
            for (var i = 0; i < services[service].queue.length; i++) {
                component = services[service].queue[i];
                component.instance = InflatorComps.render(component.class, component.props, component.element, hydrate);
                Perf.report([component.class + ' Component Async Rendered', component.element], false);
            }

            // InflatorComps.applyCtrlr(services[service].queue, service);
        }
        // else {
        //     console.log(performance.now() + ': No ' + service + ' Ctrlrs - firing applied event immediately');
        // }

        fireAppliedEvent(service);
    };

    /* inflate-comps.js is loaded into the front end asyncronusly. The call to
     * InflatorComps.applyCtrlr below adds the script tag to the DOM.
     * inflate-comps.js should load before the page has finished parsing. However, if
     * it doesn't this will be slowing down applying the component controllers to the
     * components already on the page. This could be a good thing or a bad thing, but basically as long
     * as there is no noticable delay between a button appearing on the screen and its
     * click event listener being applied then it shouldn't matter.
     * If this does become a problem you will need to use webpack to add another entry point
     * to the dependency management, so that the components already on the page can be
     * initialized on DOMContentLoaded.
     */
    InflatorComps.applyCtrlr = function (components, name) {
        // Since we don't know at this point if DOMContentLoaded has fired we need to check first
        // then apply then initialize the controllers apropriatly.
        if (!Sephora.DOMContentLoadedFired) {
            window.addEventListener('DOMContentLoaded', function () {
                InflatorComps.applyCtrlr(components, name);
            });
            return;
        }

        if (Sephora.emotionIds && Sephora.emotionIds.length) {
            emotion.hydrate(Sephora.emotionIds.split(','));
        }

        Perf.report(name + ' Applying Ctrlrs');

        var i,
            compCtrlr;

        if (typeof components === 'string') {
            var componentDataElementId = components;

            components = null;
            // Retrieve link JSON data and parse the object
            var componentsElement = document.body.querySelector('#' + componentDataElementId);
            if (componentsElement) {
                components = JSON.parse(componentsElement.innerHTML);
            }

            if (!components) {
                return;
            }

            for (i = 0; i < components.length; i++) {
                components[i].element = document.body.querySelector('[data-sephid="' + components[i].id + '"]');
            }
        }

        for (i = 0; i < components.length; i++) {
            let component = components[i];

            if (component.renderOnLoadEvent) {
                InflatorComps.queue(component.class, component.props, component.renderOnLoadEvent, component.element);
            } else {
                InflatorComps.render(component.class, component.props, component.element);
                Perf.report([component.class + ' Ctrlr Applied', component.class + ' was backend rendered, and ctrlr is now applied at: ', component.element], false);
            }
        }

        fireAppliedEvent(name);

    };

    // Initialize page components
    Perf.report('Add Components Chunk to Page');

    // require.ensure is used to package nested requires in components.chunk.js
    // rather than priority.bundle.js in order to keep priority.bundle.js lean
    require.ensure([], function (require) {
        //Create Promises
        require('analytics/promises')(Sephora.analytics);
        var inPageComponents = require('../../build/inPageList');
        Object.assign(Comps, inPageComponents);

        InflatorComps.applyCtrlr('linkJSON', 'InPageComps');

        if (Sephora.isLazyLoadEnabled) {
            const LazyLoader = require('utils/framework/LazyLoad').LazyLoaderInstance;
            LazyLoader.start();
        }

    }, 'components');

    return InflatorComps;
})();
